var calendarFac = angular.module('jv.calendarFactory', []);

    calendarFac.constant('calendarConfig', {
            height: 650,
            editable: true,
            defaultView: 'agendaDay',
            eventBackgroundColor: '#3D87CF',
            eventTextColor: '#000',
            header: {
                left:   '',
                center: '',
                right:  ''
            }
    });

    var d = new Date().getDate();
    var m = new Date().getMonth();
    var y = new Date().getFullYear();

    calendarFac.constant('d', d );
    calendarFac.constant('m', m );
    calendarFac.constant('y', y );

    calendarFac.constant('eventOrder', 0);

    calendarFac.constant('eventSources',[
    ]);

    calendarFac.constant('dates', []);
    calendarFac.constant('currentCalInstance','');
    calendarFac.constant('datePickerInstance','');

    calendarFac.constant('calendarArr',[
                    {
                        'show': false,
                        'dates': [],
                        'title': 'Jan'
                    },
                    {
                        'show': false,
                        'dates': [],
                        'title': 'Feb'
                    },
                    {
                        'show': false,
                        'dates': [],
                        'title': 'Mar'
                    },
                    {
                        'show': false,
                        'dates': [],
                        'title': 'Apr'
                    },
                    {
                        'show': false,
                        'dates':[],
                        'title': 'May'
                    },
                    {
                        'show': false,
                        'dates':[],
                        'title': 'June'
                    },
                    {
                        'show': false,
                        'dates':[],
                        'title': 'July'
                    },
                    {
                        'show': false,
                        'dates':[],
                        'title': 'Aug'
                    },
                    {
                        'show': false,
                        'dates':[],
                        'title': 'Sep'
                    },
                    {
                         'show': false,
                        'dates':[],
                        'title': 'Oct'
                    },
                    {
                         'show': false,
                        'dates':[],
                        'title': 'Nov'
                    },
                    {
                        'show': false,
                        'dates':[],
                        'title': 'Dec'
                    }
                ]);

    calendarFac.factory('jvCalendarFactory',['calendarConfig', 'eventSources', 'calendarArr', 'eventOrder', 'dates', 'currentCalInstance', 'datePickerInstance', '$interval',
                        function(calendarConfig, eventSources, calendarArr, eventOrder, dates, currentCalInstance, datePickerInstance, $interval) {

         var  calendarService = {
            init: function (userConfig, elem) {
                eventSources.length = 0;
                calendarConfig.eventClick = calendarService.alertOnEventClick;
                calendarConfig.eventResize = calendarService.alertOnResize;
                calendarConfig.drop = calendarService.alertOnDrop;
                calendarConfig.dayClick = calendarService.dayClick;

                if (userConfig) {
                    angular.extend(calendarConfig, userConfig);
                }

                //over write default settings with user settings
                $('#' + elem).fullCalendar(calendarConfig);
            },
            setCurrentCalInstance: function(cal){
                currentCalInstance = cal;
            },
            getCurrentCalInstance: function(){
                return currentCalInstance;
            },
            //Creates the event object for the date clicked and
            createDate: function(eventDates){
                    var newlyAddedEventArr = [];
                    var dates = eventDates;
                    angular.forEach(dates,function(eventDate,key){
                        if(eventDate){
                            var isEventInCalendar = calendarService.getCalendarEvents(currentCalInstance,eventDate);
                            if(!isEventInCalendar){
                                var date = new Date();
                                var d = date.getDate();
                                var m = date.getMonth();
                                var y = date.getFullYear();

                                var dateStr = new Date(eventDate);
                                var dateInMilli = dateStr.getTime();

                                var eventOrder = calendarService.updateEventOrder('plus');
                                var eventObj = {
                                    order: eventOrder,
                                    titleView: 'none',
                                    title: eventDate,
                                    day: d,
                                    month: m,
                                    year: y,
                                    allDay: false,
                                    date_time: dateInMilli,
                                    leftOffset: true
                                };
                                newlyAddedEventArr.push(eventObj);
                            }
                        }
                    });
                    return newlyAddedEventArr;
            },
            addEventSources: function(elem, sortedEventsArr){
            	angular.forEach(sortedEventsArr, function(sortedEvent, key) {
                    sortedEvent.start = sortedEvent.start || new Date(sortedEvent.year, sortedEvent.month, sortedEvent.day, 9, 0);
                    sortedEvent.start = moment(sortedEvent.start).format('YYYY-MM-DD HH:mm');


                    sortedEvent.end = sortedEvent.end || new Date(sortedEvent.year, sortedEvent.month, sortedEvent.day, 17, 0);
                    sortedEvent.end = moment(sortedEvent.end).format('YYYY-MM-DD HH:mm');
                });
            	$('#'+elem).fullCalendar('addEventSource', sortedEventsArr);
            },
            addEvent: function(elem,event){
                $('#'+elem).fullCalendar('renderEvent',event,'stick');
            },
            addEvents: function(elem, sortedEventsArr){
                angular.forEach(sortedEventsArr, function(sortedEvent, key) {
                    sortedEvent.start = sortedEvent.start || new Date(sortedEvent.year, sortedEvent.month, sortedEvent.day, 9, 0);
                    sortedEvent.start = moment(sortedEvent.start).format('YYYY-MM-DD HH:mm');

                    sortedEvent.end = sortedEvent.end || new Date(sortedEvent.year, sortedEvent.month, sortedEvent.day, 17, 0);
                    sortedEvent.end = moment(sortedEvent.end).format('YYYY-MM-DD HH:mm');
                    calendarService.addEvent(elem, sortedEvent);
                });
            },
            updateEvents: function(events){
                $('#'+currentCalInstance).fullCalendar('updateEvents', events);
            },
            resetCalendar: function(elem){
                 $('#'+elem).fullCalendar('removeEvents');
                 $('#'+elem).fullCalendar('removeEventSources');
               // eventSources.length = 0;
            },
            getCalendarEventsByFilter: function(idOrFilter){
                return $('#'+currentCalInstance).fullCalendar('clientEvents', idOrFilter);
            },
            getCalendarEvent: function(elem,id){
                var event  = $('#'+elem).fullCalendar('clientEvents',id);
                return event[0];
            },
            getCalendarEvents: function(elem,date){
                var events = $('#'+elem).fullCalendar('clientEvents');
                var i = 0;

                if (!date) {
                    // Sort the dates in chronological order
                    // Date.title format returned 10/18/2014
                    events.sort(function(date1, date2) {
                        var dateObject1 = new Date(date1.title);
                        var dateObject2 = new Date(date2.title);
                        return dateObject1.getTime() - dateObject2.getTime();
                    });
                    return events;
                } else {
                    for (i; i < events.length; i++) {
                        if (!$.isEmptyObject(events[i])) {
                            if (date === events[i].title) {
                                return events[i];
                            }
                        }
                    }
                }
            },
            /* ===========================================================================
             sortDates
             * Takes an array of objects and returns an ordered array based on year,
             * month, then day
             *
             * @param <Array> originalDatesArray
             * @return <Array> newDatesArray
             ========================================================================== */
            sortDates: function( originalDatesArray ) {
                    var originalDatesCopy = originalDatesArray;
                    var originalDatesLength = originalDatesCopy.length;
                    var i = 0;
                    var j = 0;
                    var hasHadChange = null;
                    var tempArray = null;
                    var tempOrder = null;

                    var updateOrder = function(events) {
                        angular.forEach(events, function(value, key) {
                            value.order = (key + 1);
                        });

                        return events;
                    };

                    if ( originalDatesLength > 1 ) {

                        // Check the algorithm
                        for ( i = 0; i < (originalDatesLength - 1); i++ ) {
                            hasHadChange = false;

                            for ( j = 0; j < (originalDatesLength - 1); j++ ) {
                                if( originalDatesCopy[j].date_time > originalDatesCopy[j + 1].date_time ) {
                                    hasHadChange = true;
                                    tempArray = originalDatesCopy[j];
                                    originalDatesCopy[j] = originalDatesCopy[j+1];
                                    originalDatesCopy[j+1] = tempArray;
                                }
                            }

                            if ( !hasHadChange ) {
                                originalDatesCopy = updateOrder(originalDatesCopy);
                                return originalDatesCopy;
                            }
                        }
                    }
                    originalDatesCopy = updateOrder(originalDatesCopy);
                    return originalDatesCopy;
            },
            extractEventId: function(index){
                var events = calendarService.getCalendarEvents(currentCalInstance);
                angular.forEach(events,function(evt,key){
                    if(index === key){
                        calendarService.removeEvent(evt._id);
                    }
                });

            },
            removeEvent: function(id,removeEventOnly){
                $('#'+currentCalInstance).fullCalendar('removeEvents',id);
                $('#'+currentCalInstance).fullCalendar('removeEventSource',id);
                //If removeEvents only that means we are removing events in the same column so no need to reorder
                if(!removeEventOnly){
                    calendarService.reOrderEvents();
                    calendarService.updateEventOrder('minus');
                }
                var events = calendarService.getCalendarEvents(currentCalInstance);
                if(events.length === 0){
                    calendarService.resetCalendar(currentCalInstance);
                }
            },
            //This method is used to reorder events after you remove an event
            reOrderEvents: function(){
                var unOrderedEvents = calendarService.getCalendarEvents(currentCalInstance);
                var OrderedEvents = [];
                angular.forEach(unOrderedEvents,function(evtSrc,key){
                    var dateStr = new Date(evtSrc.title);
                    var dateInMilli = dateStr.getTime();
                    var date = new Date();
                    var d = date.getDate();
                    var m = date.getMonth();
                    var y = date.getFullYear();

                    evtSrc.date_time = dateInMilli;
                    evtSrc.day = d;
                    evtSrc.month =  m;
                    evtSrc.year = y;
                    evtSrc.allDay = false;
                    evtSrc.order = (key+1);
                    OrderedEvents.push(evtSrc);
                });
                //We need to remove the events that are already in the calendar because we re-render the sorted list every time
                //calendarService.resetCalendar(currentCalInstance);
                calendarService.addEvents(currentCalInstance,OrderedEvents);
            },
            //Extracts the date and month of the event that was removed
            //oldVal holds the full list of events, newVal holds the newList of dates excluding the event that was removed
            extractDateToRemove: function(oldVal, newVal){
                angular.forEach(oldVal,function(value, key){
                    if(!calendarService.contains(value, newVal)){
                        calendarService.removeDate(key, value, newVal);
                    }
                });
            },
            removeDate: function(key, value, newVal){
                calendarService.extractEventId(key);
                var date = new Date(value);
                var dateRemoved = date.getDate();
                var m = date.getMonth();
                angular.forEach(calendarArr[m].dates,function(date,index){
                    if(date === dateRemoved){
                        calendarService.buildCalendarHeader(newVal,index,m);
                    }
                });
            },
            //Method used to sort numbers
            numberSort: function(num1,num2){
                return(num1-num2);
            },
            /**
                This method is used to add remove dates from the calendar header
                calendarArr array holds all the data related to the calendar header
                It does the following
                1: Loops through dates and checks if it already exists in the calendarArr
                2: Adds it if not found
                3: indexToRemove and month are used to remove events from a particular month from the calendarArr
            **/
            buildCalendarHeader: function(dates,indexToRemove,month){
                if(dates.length > 0){
                    angular.forEach(dates,function(date,key){
                        date = new Date(date);
                        var d = date.getDate();
                        var m = date.getMonth();
                        var y = date.getFullYear();
                        calendarArr[m].show = true;
                        if( !(calendarService.contains(d,calendarArr[m].dates))){
                            calendarArr[m].dates.push(d);
                            calendarArr[m].dates.sort(calendarService.numberSort);
                        }

                        if( (indexToRemove && indexToRemove.toString()) || (indexToRemove===0) ){

                            calendarArr[month].dates.splice(indexToRemove,1);
                            indexToRemove = false;

                            if(calendarArr[month].dates.length === 0){
                                calendarArr[month].show = false;
                            }
                        }
                    });
                }else{
                    calendarService.initCalendarArr();
                }
            },
            //Resets the calendarArr
            initCalendarArr: function(){
                angular.forEach(calendarArr,function(month,key){
                    month.show = false;
                    month.dates = [];
                });
            },
            //Returns the calendarConfig object
            getCalendarConfig: function(){
                return calendarConfig;
            },
            //Returns the calendarArr object
            getCalendarArr: function(){
                return calendarArr;
            },
            //Checks if an item exists in an array
            contains: function(item,arr){
                var len = arr.length;
                for(var i=0 ; i<len; i++){
                    if(arr[i] === item){
                        return true;
                    }
                }
                return false;
            },
            //Returns the current date of the calendar
            getDate: function(calInstance){
                var currDate;
                if(calInstance){
                    currDate = $('#'+calInstance).fullCalendar('getDate');
                }else{
                    currDate = $('#'+currentCalInstance).fullCalendar('getDate');
                }

                var date = new Date(currDate);
                var d = date.getDate();
                var m = date.getMonth();
                var y = date.getFullYear();
                dateObj = {
                    d: d,
                    m: m,
                    y: y
                };
                 var dateStr = (dateObj.m-1)+'-'+(dateObj.d)+'-'+dateObj.y
                return dateStr;

            },
            //Accepts a date object and paginates calendar instance to that date
            paginateCalendarTo: function(date){
                $('#'+currentCalInstance).fullCalendar('gotoDate',date.y,date.m,date.d);
            },
            //accepts moment / date object
            jumpToDate: function(date){
                $('#'+currentCalInstance).fullCalendar('gotoDate', date);
            },
            //Returns the current event order
            getEventOrder: function(){
                return eventOrder;
            },
            //Resets event order
            resetEventOrder: function(){
                eventOrder = 0;
                angular.element($('#calendarController')).scope().eventOrder = 0;
                return eventOrder;
            },
            //updatesEvent order
            updateEventOrder: function(direction){
                if(direction == 'plus'){
                     eventOrder ++;
                     angular.element($('#calendarController')).scope().eventOrder++;
                }else{
                     eventOrder --;
                     angular.element($('#calendarController')).scope().eventOrder--;
                }
                return eventOrder;
            },
            //set Date Picker Instance from web page
            setDatePickerInstance: function(dateIns){
                datePickerInstance = dateIns;
            },
            getDatePickerInstance: function(){
                return datePickerInstance || '.multiDatepicker';
            },
            //getting dates ONLY IN CASE OF MULTISELECT
            getDatePickerDates: function(){
                return $(calendarService.getDatePickerInstance()).multiDatesPicker('getDates');
            },
            addDateToDatePicker: function(dates, type){
                var domChecker;
                type = type || 'picked';

                if (dates && dates.length) {
                    domChecker = $interval(function() {
                        if($(calendarService.getDatePickerInstance()).find(".hasDatePicker")) {

                            $('.hasDatepicker').multiDatesPicker('addDates', dates, type);
                            $interval.cancel(domChecker);
                        }
                    }, 300);
                }
            },
            highlightDays: function(date){
                if(calendarService.getDatePickerArr() && calendarService.getDatePickerArr().length > 0){
                    if(calendarService.getDatePickerArr().indexOf(date.getTime()) > -1){
                        return [true, 'jv-state-selected'];
                    }
                }
                return [true, ''];
            },
            addClassToDates: function(){
                $(calendarService.getDatePickerInstance()).datepicker('option', 'beforeShowDay', calendarService.highlightDays);
            },
            removeDateFromDatePicker: function(index){
                $('.hasDatepicker').multiDatesPicker('removeDates',index);
            },
            resetDatePickerDates: function(){
                $('.hasDatepicker').multiDatesPicker('resetDates');
            },
            updateDatePickerArr: function(datesArr){
                dates = datesArr;
            },
            getDatePickerArr: function(){
                return dates;
            },
            resetDatePickerArr: function(){
                $(calendarService.getDatePickerInstance()).multiDatesPicker('resetDates');
                dates.length = 0;
                angular.element($('#calendarController')).scope().dates.length = 0;
            }
        };
        return calendarService;
    }]);
